import topic from '../topic'
export const pstkAPI = {
    getPstks: topic.pstkTopic + '/get_pstks',
    getPstkById: topic.pstkTopic + '/get_pstk_by_id',
    addPstk: topic.pstkTopic + '/add_pstk',
    editPstk: topic.pstkTopic + '/edit_pstk',
    deletePstkByIds: topic.pstkTopic + '/delete_pstk_by_ids'
}